import React, { useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Tooltip, OverlayTrigger, Button,  } from 'react-bootstrap';
import LoadinSpin from '../../ui/LoadinSpin';
import { AuthContext } from '../../../auth/AuthContext';
import DropDownsCol from '../../ui/DropDownsCol';

import { useGetDta } from '../../../hooks/useGetDta';
import { TblDocs, headTbl } from '../../../data/tables';
import {  useShowColumsHook } from '../../../hooks/useShowColums';
import Table from '../../Table';
import ModDoc from './ModDoc';
import moment from 'moment';
import EditDocument from './EditDocument';
import Confirmation from '../../ui/Confirmation';
import { checkAccess } from '../../../helpers/details';

import ContratoUs from './ContratoUs';
import { getInitialColumns } from '../../../data/cards';  
const baseUrl = process.env.REACT_APP_API;

const DocsUser = ({ activeTab }) => {
    const { id } = useParams();

    const initialColums = getInitialColumns('docs/', TblDocs);
    const { toggleCheck, columnasVisibles } = useShowColumsHook(initialColums, 'docs/');


    let idR = atob(id);
    const { loading, data, getInfo } = useGetDta(`user/docs/${idR}`);
    const { auth } = useContext(AuthContext);
  const permisos = checkAccess('Documentos', auth.accesos);
      const {
        doc_agregar,
        doc_editar,
        doc_eliminar} = permisos.functions
  const permisose = checkAccess('Contratos', auth.accesos);
      

    const [show, setShow] = useState(false);
    const [showe, setShowe] = useState(false);
    const [showd, setShowd] = useState(false);
    const [item, setItem] = useState();
    const [info, setInfo] = useState({});
    useEffect(() => {
        if (activeTab === 'docs') getInfo();
    }, [activeTab, idR]);

    const openEdit = (it) => {
        setItem(it);
        setShowe(true);
    };
    const del = (id) => {
        setInfo({ id, type: 'DOCUMENTO' });
        setShowd(true);
    };
    const StatusColumn = ({ row }) => {
        return (
            <>
                <a href={baseUrl + row.original.foto} target="_blank" rel="noopener noreferrer">
                    {row.original.titulo}.pdf
                </a>
            </>
        );
    };
    const FechaColumn = ({ row }) => {
        const { createdAt } = row.original;
        return (
            <>
                <span>{moment(createdAt).format('YYYY/MM/DD, h:mm:ss a')}</span>{' '}
            </>
        );
    };
    const ActionColumn = ({ row }) => {
        return (
            <>
                <>
                    {doc_editar && (
                        <OverlayTrigger
                            className="action-icon "
                            placement="left"
                            overlay={<Tooltip id="overlay-example"> Editar</Tooltip>}>
                            <i className="mdi mdi-pencil mdi-18px " onClick={() => openEdit(row.original)}></i>
                        </OverlayTrigger>
                    )}
                    {doc_eliminar && (
                        <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-example"> Borrar </Tooltip>}>
                            <i className="mdi mdi-delete mdi-18px " onClick={() => del(row.original.id)}></i>
                        </OverlayTrigger>
                    )}
                </>
            </>
        );
    };
    const columns = [
        {
            Header: 'Creado Por',
            accessor: 'agente',
            sort: true,
        },
        {
            Header: 'Titulo',
            accessor: 'titulo',
            sort: true,
        },
        {
            Header: 'Descripción',
            accessor: 'nota',
            sort: true,
        },
        {
            Header: 'Archivo',
            accessor: 'foto',
            sort: true,
            Cell: StatusColumn,
        },
        {
            Header: 'Fecha',
            accessor: 'createdAt',
            sort: true,
            Cell: FechaColumn,
        },

        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const sizePerPageList = headTbl(data.length);

    if (loading) return <LoadinSpin />;
    return (
        <div className="pt-2">
            <Row>
                {permisose.access && <ContratoUs activeTab={activeTab} />}
                <Col>
                    {' '}
                    <Row className="mb-2">
                        <Col xs="auto">
                            {doc_agregar && (
                                <Button type="button" onClick={() => setShow(true)}>
                                    <b>+</b> Nuevo
                                </Button>
                            )}
                        </Col>
                        <Col>
                            <DropDownsCol
                                cols={columnasVisibles} // Pasar el estado desde TblZonas
                                toggleCheck={toggleCheck} // Pasar la función de toggleCheck desde TblZonas
                            />
                        </Col>
                    </Row>
                    <Table
                        columns={columns}
                        data={data}
                        pageSize={25}
                        sizePerPageList={sizePerPageList}
                        isSortable={true}
                        pagination={true}
                        isSearchable={true}
                    />
                </Col>
            </Row>

            <ModDoc show={show} callBk={getInfo} onClose={() => setShow(false)} idc={idR} />
            <EditDocument show={showe} callBk={getInfo} onClose={() => setShowe(false)} data={item} />

            <Confirmation show={showd} toggle={() => setShowd(false)} info={info} callBk={getInfo} />
        </div>
    );
};

export default DocsUser;
